import { render, staticRenderFns } from "./DomainNew.vue?vue&type=template&id=818c9532&"
import script from "./DomainNew.vue?vue&type=script&lang=js&"
export * from "./DomainNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports